<template>
  <div id="rate-list" class="list">
    <div class="grid-row">
      <div class="column">
        <div class="rate-list-header list-header">
          <ul>
            <li>{{$_('reference')}}</li>
            <li>{{$_('designation')}}</li>
            <li>{{$_('size')}}</li>
            <li>{{$_('packaging')}}</li>
            <li>{{$_('code')}}</li>
            <li>{{$_('color')}}</li>
            <li>{{$_('footage')}}</li>
            <li>{{$_('quantity_slice')}}</li>
            <li>{{$_('rate')}}</li>
            <li>{{$_('unit')}}</li>
          </ul>
        </div>
        <div class="rate-list-body list-body">
          <div v-for="(item, index) in items" :key="index">
            <RateLine :dataline="item" :index="index" />
          </div>
        </div>
      </div>
    </div>
    <div class="grid-row">
      <div class="column">
        <Pagination
          :nNumeroPage="pagination_info.nNumeroPage"
          :nNombreElementParPage="pagination_info.nNombreElementParPage"
          :nNbElementTotal="pagination_info.nNbRecordData"
          :sTypeElement="$_('rates')"
          :fn="getRate"
        />
      </div>
    </div>
  </div>
</template>

<script>
import rateService from "../services/rateService";

import RateLine from "@/modules/tarif/components/RateLine";
import Pagination from "@/common/components/widget/Pagination/Pagination";

export default {
  name: "RateList",
  components: {
    RateLine,
    Pagination
  },
  computed: {
    getResearch() {
      return this.$store.getters["tarif/get_research"];
    }
  },
  data() {
    return {
      items: [],
      nResult: 0,
      pagination_info: {
        nNumeroPage: 1,
        nNombreElementParPage: 20,
        nNbRecordData: 0
      }
    };
  },
  created() {
    this.getRate();
  },
  methods: {
    getRate(nNumeroPage, nNombreElementParPage) {
      let poffset = 0;

      if (nNumeroPage > 1) {
        poffset = nNumeroPage * nNombreElementParPage - nNombreElementParPage;
      }

       this.items = Array();

      return rateService
        .getCustomerRate({
          fmod: this.$store.getters["tarif/get_fmod"],
          ftail: this.$store.getters["tarif/get_ftail"],
          pnlot: this.$store.getters["tarif/get_pnlot"],
          poffset
        })
        .then(res => {
          this.pagination_info.nNbRecordData = res.data.NB_RECORD;
          if (res.data.DS_O !== undefined) {
            
            if (this.$store.getters["tarif/get_reset_rate_list"] === true) {
              this.items = Array();
            }

            res.data.DS_O.OUT.map(obj => {
              this.items.push(obj);
            });

            this.$store.dispatch("tarif/LAUNCH_RESEARCH", { launch: false });
            this.$store.dispatch("tarif/SELECT", {
              key: "reset_rate_list",
              value: false
            });

            return this.pagination_info;
          }
        })
        .catch(err => {
          console.error(err);
        });
    }
  },
  watch: {
    getResearch(value) {
      if (value === true) {
        this.getRate();
      }
    }
  }
};
</script>

<style scoped>
#rate-list {
  padding: 0px 0px;
}
.rate-list-header ul {
  display: flex;
}
.rate-list-header ul li {
  list-style-type: none;
  display: flex;
  width: calc(100% / 10);
  text-align: center;
  padding: 0px 20px;
  justify-content: center;
}
.rate-list-header {
  padding: 15px 0px;
}
</style>